import React from "react";
import { useCustomerPermissions } from "../../../components/Billings/lib/useCustomerPermissions";

import { ErrorMessage } from "../../../components/shared/ErrorMessage/ErrorMessage";
import { GroupsView } from "./GroupsView";
import { RestrictedPage } from "../../RestrictedPage/RestrictedPage";

export const Groups = () => {
  const { loading, error, isBussinesOrPro } = useCustomerPermissions();

  if (loading || isBussinesOrPro) {
    return <GroupsView />;
  }

  if (error) {
    return (
      <ErrorMessage message="Error fetching user plan, please try reloading the page!" />
    );
  }

  return <RestrictedPage title="Manage user groups" />;
};
